import { OrderType, SignedSaleOrder } from "@/api/orders/types";
import { User } from "@/api/users/types";

export const isReserveAuction = (auction?: SignedSaleOrder) => {
  return auction?.type === OrderType.RESERVE_AUCTION;
};

export const isUserPrivateAuctionParticipant = (
  user?: User,
  auction?: SignedSaleOrder,
) => {
  if (!user || !auction) return null;

  return (
    auction?.type === OrderType.PRIVATE_AUCTION &&
    (user?.address === auction?.seller || user.address === auction.buyer)
  );
};
